<h4 class="d-flex justify-content-between align-items-center position-relative">
    <span>
        Recherches sauvées
    </span>
    <span class="position-absolute end-0">
        <idel-infos-chip [info]="'Cliquer sur une recherche pour la charger'" [size]="'small'"
            [infoPosition]="'left'"></idel-infos-chip>
    </span>
</h4>
<div class="saved-searches__list">
    @if(!fetchingSavedSearches()) {
    @for(search of savedSearches(); track search.id) {
    <div class="saved-searches__list__item" (click)="onClick.emit(search)">
        <span>
            @if(search.hideInDashboard) {
            <i class="bi bi-eye-slash-fill" [pTooltip]="'Non visible dans le dashboard'"></i>
            }@else {
            <i class="bi bi-eye-fill" [pTooltip]="'Visible dans le dashboard'"></i>
            }
        </span>
        <span class="saved-searches__list__item__label ms-2">
            {{search.description}}
        </span>
        <div class="saved-searches__list__item__actions ms-auto">
            <span class="cursor-pointer" (click)="$event.stopPropagation(); onEditSavedSearch(search)"
                [pTooltip]="'Modifier cette recherche'" [tooltipPosition]="'left'">
                <i class="bi bi-pencil-square"></i>
            </span>
            <span class="cursor-pointer" style="color: var(--red-inforius);"
                (click)="$event.stopPropagation(); onDeleteSavedSearch(search)" [pTooltip]="'Supprimer cette recherche'"
                [tooltipPosition]="'left'">
                <i class="bi bi-trash-fill"></i>
            </span>
        </div>
    </div>
    }@empty {
    <div class="saved-searches__list__empty">
        Aucune recherche sauvegardée.
    </div>
    }
    }
    @else {
    <div class="d-flex align-items-center justify-content-center w-100 h-100">
        <i-loader></i-loader>
    </div>
    }
</div>

<p-dialog
    [header]="'Modifier la recherche sauvée : ' + (savedSearchToUpdate() ? savedSearchToUpdate().description : '')"
    [(visible)]="isSavedSearchUpdateDialogOpen" (visibleChange)="cancelUpdate()">
    <form [formGroup]="updateSavedSearchFormGroup">
        <div class="d-flex flex-column  mb-3">
            <div class="d-flex flex-column mb-2">
                <label class="input-label">Description*</label>
                <input pInputText formControlName="description" />
            </div>
            <div class="d-flex flex-column mb-2">
                <label class="input-label">Ordre d'affichage</label>
                <p-inputNumber formControlName="order" />
            </div>
            <div class="d-flex flex-row align-items-center gap-2">
                <p-checkbox formControlName="hideInDashboard" [binary]="true"></p-checkbox>
                <label class="input-label mb-0">Cacher dans le dashboard</label>
            </div>
        </div>
        <div>
            <i-button [styleClass]="'blue'" [text]="'Modifier'" (click)="updateSavedSearch()"
                [disabled]="updateSavedSearchFormGroup.invalid"></i-button>
        </div>
    </form>
</p-dialog>

<idel-confirm-dialog [(open)]="isDeleteSavedSearchConfirmDialogOpen"
    (onConfirm)="deleteSavedSearch()"></idel-confirm-dialog>